import Dispatcher from '../dispatcher/CentricDispatcher.react';
import { ActionTypes } from '../constants/CentricConstants';
import LabelApi from '../server/LabelApi';

export default {
    getAll: (params) => {
        const types = {
            request: ActionTypes.LABEL_LIST_REQUEST,
            success: ActionTypes.LABEL_LIST_SUCCESS,
            failure: ActionTypes.LABEL_LIST_FAILURE
        };

        return Dispatcher.dispatchAsync(LabelApi.getAll(params), types, params);
    },

    addLabel: (params) => {
        const types = {
            request: ActionTypes.LABEL_SAVE_REQUEST,
            success: ActionTypes.LABEL_SAVE_SUCCESS,
            failure: ActionTypes.LABEL_SAVE_FAILURE
        };

        return Dispatcher.dispatchAsync(LabelApi.save(params), types, params);
    },

    updateLabel: (id, params) => {
        const types = {
            request: ActionTypes.LABEL_UPDATE_REQUEST,
            success: ActionTypes.LABEL_UPDATE_SUCCESS,
            failure: ActionTypes.LABEL_UPDATE_FAILURE
        };

        return Dispatcher.dispatchAsync(LabelApi.update(id, params), types, {id, ...params});
    },

    deleteLabel: (id) => {
        const types = {
            request: ActionTypes.LABEL_DELETE_REQUEST,
            success: ActionTypes.LABEL_DELETE_SUCCESS,
            failure: ActionTypes.LABEL_DELETE_FAILURE
        };

        return Dispatcher.dispatchAsync(LabelApi.delete(id), types, { id });
    }
};
